/**
 * Search in content by given criteria.
 *
 * @module searcher
 */

'use strict';

var MODE_SUB_STRING   = 1,
    MODE_FUZZY_STRING = 2,
    MODE_WILD_CARD    = 3,
    settings = {
        // default
        mode: MODE_SUB_STRING,
        matchCase: false
    },
    stringToRegExp = (function () {
        var cache = {};

        /**
         * Construct regular expression from given string.
         *
         * @param {string} string - source string to convert
         *
         * @return {RegExp} constructed regular expression
         */
        return function ( string ) {
            if ( !cache[string] ) {
                cache[string] = new RegExp(string, settings.matchCase ? '' : 'i');
            }

            return cache[string];
        };
    })(),
    matchers = {},
    rawSearchRequest;


/**
 * Interpret given wildcard and translate it to a regular expression for searching.
 *
 * @param {string} wildcard - wildcard for interpreting
 *
 * @return {RegExp} constructed regular expression
 */
// function interpretWildcard ( wildcard ) {}


/**
 * Search in the given string.
 *
 * @param {string} string - string to search on
 *
 * @return {boolean} test result -- matched or not
 */
function searchSubstring ( string ) {
    return stringToRegExp(rawSearchRequest).test(string);
}


/**
 * Fuzzy searching based on Levenshtein distance calculation.
 *
 * @param {Object[]} data - raw data for searching
 *
 * @return {Object[]} filtered data
 */
// function searchFuzzy ( data ) {}


/**
 * Search by given wildcard.
 */
// function searchWildcard () {}


matchers[MODE_SUB_STRING]   = searchSubstring;
// matchers[MODE_FUZZY_STRING] = searchFuzzy;
// matchers[MODE_WILD_CARD]    = searchWildcard;


/**
 * Setup search mode including case sensitivity.
 *
 * @param {Object} config - search config to use
 * @param {number} config.mode - constant type of search mode
 * @param {boolean} config.matchCase - should search be case sensitive
 */
function setup ( config ) {
    settings.mode = config.mode || MODE_SUB_STRING;
    settings.matchCase = config.matchCase || false;
}


/**
 * Search by given data.
 *
 * @param {(string[]|Object[])} data - data for search
 * @param {Function} getPointer - function that emits element for search matches
 * @param {Function} [callback] - handle operation result, asynchronous scenario
 */
// eslint-disable-next-line
function search ( data, getPointer, callback ) {
    var matcher = matchers[settings.mode],
        filtered = data.filter(function ( item ) {
            return matcher(getPointer(item));
        });

    if ( callback ) {
        callback(filtered);
    } else {
        return filtered;
    }
}


module.exports = {
    get searchRequest () {
        return rawSearchRequest;
    },
    set searchRequest ( request ) {
        rawSearchRequest = request;
    },
    modeSubString: MODE_SUB_STRING,
    modeFuzzy:     MODE_FUZZY_STRING,
    modeWildCard:  MODE_WILD_CARD,
    setup:         setup,
    search:        search
};
